import { FC, useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { Select } from 'components/Controls';
import { countries } from 'components/LanguageSelect';
// Components
import AdditionalLanguageItem from './AdditionalLanguageItem';

const Languages:FC = () => {
  const { t } = useTranslation('common');

  const { control, watch, setValue } = useFormContext();

  const watchedAdditionalLanguages = watch('additionalLanguages');

  const [additionalLanguages, setAdditionalLanguages] = useState<string[]>(watchedAdditionalLanguages || []);

  const handleAdditionalLanguages = (language: string) => {
    if (additionalLanguages.includes(language)) {
      setAdditionalLanguages(prev => prev.filter(lng => lng !== language));
    } else {
      setAdditionalLanguages(prev => ([...prev, language]));
    }
  }

  useEffect(() => {
    setValue('additionalLanguages', additionalLanguages);
    // eslint-disable-next-line
  }, [additionalLanguages]);

  const watchedLanguage = watch('language');

  useEffect(() => {
    setAdditionalLanguages(prev => prev.filter(lng => lng !== watchedLanguage));
    // eslint-disable-next-line
  }, [watchedLanguage]);

  return (
    <div>
      <Controller
        control={control} name="language"
        render={({ field }) => (
          <Select
            {...field}
            label={t('ownerPage.quizForm.quizLanguage')} id="language" name="language"
            options={countries}
          />
        )}
      />
      <div>
        <p className="text-white text-sm font-semibold mb-2">{t('ownerPage.quizForm.additionalLanguages')}</p>
        <span className="block text-gray-400 text-sm font-light leading-5 mb-2">{t('ownerPage.quizForm.additionalLanguagesHint')}</span>
        {countries.filter(country => country.value !== watchedLanguage).map(c => {
          const checked = additionalLanguages.includes(c.value);
          return (
            <AdditionalLanguageItem key={`language-${c.value}`} country={c} handleAdditionalLanguages={handleAdditionalLanguages} checked={checked} />
          )
        })}
      </div>
    </div>
  )
}

export default Languages;
